<template>
  <div>
    <card title="Reports" :isFullPage="true">
        <div class="col-md-4 offset-md-8">
        <fg-input
          type="text"
          placeholder="Search"
          v-model="query"
          @keyupEnter="search"
          @clickedIcon="search"
          addonRightIcon="search"
          :iconClasses="['clickable']"
        >
        </fg-input>
      </div>
      <pagination-display
        v-if="deviceReports"
        :skip="skip"
        :count="count"
        :perPage="perPage"
        :lastIndex="lastIndex"
        @updatePerPage="updatePerPage"
      />
      <b-table
        id="device-link-reports-table"
        :fields="filteredTableFields"
        :items="deviceReports"
        show-empty
        :busy="isLoading"
        @sort-changed="sortingChanged"
        :sort-by="sortBy"
        :sort-desc.sync="sortDesc"
        :no-local-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle mr-3"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <!-- <template v-slot:head(select)>
          <div class="form-check row-select">
            <input
              type="checkbox"
              v-model="selectAll"
              @change="toggleSelection"
              class="form-check-input"
            />
          </div>
        </template> -->
        <!-- <template v-slot:cell(select)="row">
          <div class="form-check row-select">
            <input
              type="checkbox"
              :disabled="selectAllPages"
              :value="row.item.isSelected"
              :checked="row.item.isSelected"
              @input="selectRow(row.item)"
              class="form-check-input"
            />
          </div>
        </template> -->
        <template v-slot:cell(view)="row">
          <router-link
            :to="`/device-link/reports/${row.item.id}`"
            class="page-link text-info text-center"
          >
            <font-awesome-icon icon="desktop" />
          </router-link>
        </template>

        <template v-slot:cell(created_at)="row">{{
          row.item.created_at | prettyDateTime
        }}</template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        @change="fetchDeviceLinkReports"
        :total-rows="count"
        :per-page="perPage"
      >
      </b-pagination>
    </card>
  </div>
</template>

<script>
import Card from "../Cards/Card";
import PaginationDisplay from "./PaginationDisplay";
import { mapGetters } from "vuex";

export default {
  name: "DeviceLinkReportsTable",
  components: {
    Card,
    PaginationDisplay,
  },
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      query: '',
    };
  },
  mounted() {
    // clean up store when returning to page
    this.$store.commit("deviceReport/selectAllPages", false);
  },
  methods: {
    async fetchDeviceLinkReports(page) {
      if (page) {
        this.currentPage = page;
      }

      this.isLoading = true;
      await this.$store.dispatch("deviceReport/fetchDeviceReports", {
        skip: this.skip,
        limit: this.perPage,
      });
      this.isLoading = false;
    },
    updatePerPage(perPage) {
      this.perPage = perPage;
      this.fetchDeviceLinkReports(1);
    },
    sortingChanged(context) {
      this.sortBy = context.sortBy;
      this.sortDesc = context.sortDesc;
      this.fetchDeviceLinkReports();
    },
    search() {
      console.log(`Settings searchQuery to value = ${this.query}`)
      this.$store.commit("deviceReport/searchQuery", this.query);
      this.fetchDeviceLinkReports(1);
    },
    clearSearch() {
      this.$store.commit('deviceReport/searchQuery', '');
      this.fetchDeviceLinkReports(1);
    },
  },
  computed: {
    ...mapGetters("user", ["isSuperUser", "isStaffUser"]),
    ...mapGetters("deviceReport", [
      "deviceReports",
      "count",
      "tableFields",
      "selectAllPages",
      "selectedCount",
      "searchQuery"
    ]),
    filteredTableFields() {
      if (this.isStaffUser || this.isSuperUser) {
        return this.tableFields;
      }
      else {
        return this.tableFields.filter(item => item.key !== "organization.name");
      }
    },
    sortBy: {
      get() {
        return this.$store.state.deviceReport.sortBy;
      },
      set(value) {
        this.$store.commit("deviceReport/sortBy", value);
      },
    },
    sortDesc: {
      get() {
        return this.$store.state.deviceReport.sortDesc;
      },
      set(value) {
        this.$store.commit("deviceReport/sortDesc", value);
      },
    },
    perPage: {
      get() {
        return this.$store.state.deviceReport.perPage;
      },
      set(value) {
        this.$store.commit("deviceReport/perPage", value);
      },
    },
    skip() {
      return (this.currentPage - 1) * this.perPage;
    },
    hasSelection() {
      return this.selectedCount > 0;
    },
    lastIndex() {
      return this.skip + this.deviceReports.length;
    },
    isDefaultTable() {
      return true;
    },
  },
};
</script>
<style>
.scroll {
  overflow-x: scroll;
}

.subtable {
  max-width: 75vw;
  overflow: scroll;
}

.table-bar {
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
}

.pagination-results {
  margin-top: 8px;
}

.ziperase-toolbar {
  margin-bottom: 0px;
  cursor: pointer;
}

.row-select {
  margin-top: -12px;
}
th {
    font-size: 1.0em !important;
}
</style>
